// components/PrivateRoute.js
import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import axios from 'axios'
const ProtectedAdminRoute = ({ children }) => {
    const authenticityCheckPath = `${process.env.REACT_APP_API_URL}api/Auth/me`
    const token = localStorage.getItem("token");
    const email = localStorage.getItem("userEmail");
    const role = localStorage.getItem("role");
    const userId = localStorage.getItem("userId")
    const [isAllowed, setIsAllowed] = useState(false)
    const [isLoading, setIsLoading] = useState(true); // 👈 new loading state

    const checkIfAdmin = async () => {
        try {
            const response = await axios.get(authenticityCheckPath, {
                headers: {
                    Authorization: `Bearer ${token}`, // Include the token in the header
                    'Content-Type': 'application/json'
                }
            })
            const userInfo = response.data.data
            if (userInfo.email === email && userInfo.roles[0] === role && userInfo.id===userId) {
                setIsAllowed(true)
            }
        } catch (err) {
            console.error("Auth check failed", err);
        } finally {
            setIsLoading(false); // 👈 done loading regardless of success/failure
        }
    }
    useEffect(() => {
        checkIfAdmin()
    }, [])
    if (isLoading) return null; // 👈 Don't render anything while loading
    return isAllowed ? children : <Navigate to="/login" replace />;
};

export default ProtectedAdminRoute;
